// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop_backToTop__pkDoa","noLabel":"BackToTop_noLabel___9rWv"};